import { DELETE_LOCAL_SALON_TAG } from './deleteLocalSalonTag.types';

const deleteLocalSalonTag = (data) => ({
  type: DELETE_LOCAL_SALON_TAG,
  data,
});

export default deleteLocalSalonTag;
